import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "tw-relative"
};
var _hoisted_2 = ["src", "onClick"];
var _hoisted_3 = {
  key: 1,
  class: "tw-relative"
};
var _hoisted_4 = ["src", "onClick"];
var _hoisted_5 = {
  key: 2,
  id: "zonesmobile",
  ref: "zones",
  class: "tw-relative tw-text tw-leading-4"
};
var _hoisted_6 = {
  id: "zone-list",
  class: "tw-overflow-auto tw-rounded-xs tw-mt-15px tw-no-scrollbar tw-block tw-border tw-border-w-secondary tw-shadow-none tw-w-full",
  style: {
    "max-height": "400px"
  }
};
var _hoisted_7 = {
  class: "tw-ml-10px tw-mt-10px tw-mb-5px"
};
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["data-place-id", "data-url", "title"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["data-place-id", "data-url", "title"];
var _hoisted_12 = {
  key: 3,
  id: "map-boxes",
  class: "tw-mb-30px"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_autocomplete = _resolveComponent("base-autocomplete");
  var _component_checkbox_btn = _resolveComponent("checkbox-btn");
  var _component_base_accordion_item = _resolveComponent("base-accordion-item");
  var _component_radio_button = _resolveComponent("radio-button");
  var _component_draw_icon = _resolveComponent("draw-icon");
  var _component_base_button = _resolveComponent("base-button");
  var _component_location_icon = _resolveComponent("location-icon");
  var _component_base_bt_modal = _resolveComponent("base-bt-modal");
  return _openBlock(), _createBlock(_component_base_bt_modal, {
    id: "place-modal",
    "data-cy": "place-modal",
    style: {
      "z-index": "1053"
    },
    "show-modal": _ctx.openPlaceModal,
    "header-title": _ctx.labels.choosePlace,
    "custom-modal-header-classes": "tw-flex tw-py-15px",
    "custom-modal-body-classes": "tw-h-[calc(100%-52px)]",
    "custom-modal-footer-classes": "tw-fixed tw-bottom-0 tw-w-full",
    "with-custom-footer": _ctx.cityModal && !_ctx.valuation && _ctx.placeTest.cityID !== null || _ctx.showZoneModal,
    "with-close-icon": true,
    "full-height": true,
    onClosed: _ctx.hidePlaceModal
  }, _createSlots({
    body: _withCtx(() => [_ctx.valuation ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_base_autocomplete, {
      id: "valuationAddress",
      modelValue: _ctx.valuationAddress,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.valuationAddress = $event),
      label: _ctx.labels.address,
      "on-input-change-cb": _ctx.onInputChangeCb,
      "on-option-selected-cb": _ctx.optionSelectedCb,
      "dropdown-classes": "!tw-relative"
    }, {
      righticon: _withCtx(_ref => {
        var {
          handleClean
        } = _ref;
        return ["".concat(_ctx.valuationAddress).length > 0 ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: "".concat(_ctx.cdn, "/_ui/img/Ico/close.svg"),
          class: "text-input-icon right sm",
          alt: "Clean Icon",
          onClick: _withModifiers($event => {
            handleClean();
          }, ["stop"])
        }, null, 8 /* PROPS */, _hoisted_2)) : _createCommentVNode("v-if", true)];
      }),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "label", "on-input-change-cb", "on-option-selected-cb"])])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_base_autocomplete, {
      id: "place",
      ref: "placeAutocomplete",
      "data-cy": "place-autocomplete",
      "model-value": _ctx.autocompleteValue,
      "on-input-change-cb": _ctx.getPlaceFn,
      "disable-cb": _ctx.disableCb,
      label: _ctx.labels.place,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = obj => _ctx.managePlace(obj.payload)),
      onClick: _cache[2] || (_cache[2] = $event => _ctx.handleClick())
    }, {
      righticon: _withCtx(_ref2 => {
        var {
          handleClean
        } = _ref2;
        return ["".concat(_ctx.autocompleteValue).length > 0 ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: "".concat(_ctx.cdn, "/_ui/img/Ico/close.svg"),
          class: "text-input-icon right sm",
          alt: "Clean Icon",
          onClick: _withModifiers($event => {
            handleClean();
            _ctx.clearCautocomplete();
          }, ["stop"])
        }, null, 8 /* PROPS */, _hoisted_4)) : _createCommentVNode("v-if", true)];
      }),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["model-value", "on-input-change-cb", "disable-cb", "label"])])), !_ctx.areZonesAndLocalitiesEmpty() && _ctx.showZoneModal ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("ul", _hoisted_6, [_createElementVNode("li", _hoisted_7, [_createVNode(_component_checkbox_btn, {
      id: "whole-municipality-checkbtn",
      "data-cy": "whole-municipality-checkbtn",
      class: "tw-flex tw-items-center",
      "input-class": "tw-shrink-0",
      label: _ctx.labels.wholeMunicipality,
      checked: !_ctx.isZoneOrLocalitySelected() && !(Object.keys(_ctx.districtSelected).length > 0),
      onChange: _cache[3] || (_cache[3] = $event => {
        _ctx.onWholeMunicipalityClick();
        _ctx.disableCb = true;
      })
    }, null, 8 /* PROPS */, ["label", "checked"])]), _ctx.areZonesAndLocalitiesFilled() ? (_openBlock(), _createElementBlock("li", {
      key: 0,
      class: "select-group tw-capitalize tw-font-semibold tw-ml-3 tw-mt-10px tw-mb-5px",
      innerHTML: _ctx.zonesLabel
    }, null, 8 /* PROPS */, _hoisted_8)) : _createCommentVNode("v-if", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneList, zone => {
      return _openBlock(), _createElementBlock("li", {
        key: zone.zoneID,
        ref_for: true,
        ref: "zone".concat(zone.zoneID),
        "data-element": "",
        "data-place-id": zone.placeID,
        "data-url": zone.zoneURL,
        title: zone.zoneName,
        class: _normalizeClass([{
          'active': _ctx.isZoneSelected(zone.zoneID)
        }, "tw-ml-10px"])
      }, [zone.subPlaces.length > 0 ? (_openBlock(), _createBlock(_component_base_accordion_item, {
        key: 0,
        id: 'accordionWrapper_' + zone.zoneID,
        "arrow-width": 18,
        "btn-classes": "tw-p-10px"
      }, {
        custom_content: _withCtx(() => [_createVNode(_component_checkbox_btn, {
          id: 'checkbox_' + zone.zoneID,
          "data-id": 'checkbox_' + zone.zoneID,
          "wrapper-margin-y": "tw-py-15px",
          label: zone.zoneName,
          "label-class": "tw-text-left tw-truncate tw-w-full",
          "container-id": 'accordionWrapper_' + zone.zoneID,
          "container-class": "tw-truncate tw-w-full",
          checked: _ctx.isZoneSelected(zone.zoneID),
          onChange: $event => {
            _ctx.removeTopLocalitySelected();
            _ctx.onPlaceLIClick(zone, _ctx.updatePlaceName);
            _ctx.disableCb = true;
          }
        }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"])]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zone.subPlaces, district => {
          return _openBlock(), _createBlock(_component_checkbox_btn, {
            id: district.districtID,
            key: district.districtID,
            "wrapper-margin-y": "tw-py-5px",
            "input-class": "tw-shrink-0",
            label: district.districtName,
            "label-class": "tw-text text-truncate cb-max-width tw-leading-normal",
            checked: _ctx.isDistrictSelected(district.zoneID, district.districtID) || _ctx.areAllDistrictsSelected(zone.zoneID),
            onChange: $event => {
              _ctx.onDistrictClick(zone, district, _ctx.updatePlaceName);
              _ctx.disableCb = true;
            }
          }, null, 8 /* PROPS */, ["id", "label", "checked", "onChange"]);
        }), 128 /* KEYED_FRAGMENT */))]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"])) : (_openBlock(), _createBlock(_component_checkbox_btn, {
        key: 1,
        id: 'checkbox_' + zone.zoneID,
        "data-id": 'checkbox_' + zone.zoneID,
        label: zone.zoneName,
        "wrapper-margin-y": "tw-py-15px",
        "container-id": 'accordionWrapper_' + zone.zoneID,
        "container-class": "tw-pr-25px tw-truncate",
        "label-class": "tw-text-left tw-truncate tw-w-full",
        checked: _ctx.isZoneSelected(zone.zoneID),
        onChange: $event => {
          _ctx.removeTopLocalitySelected();
          _ctx.onPlaceLIClick(zone, _ctx.updatePlaceName);
          _ctx.disableCb = true;
        }
      }, null, 8 /* PROPS */, ["id", "data-id", "label", "container-id", "checked", "onChange"]))], 10 /* CLASS, PROPS */, _hoisted_9);
    }), 128 /* KEYED_FRAGMENT */)), _ctx.localityList.length ? (_openBlock(), _createElementBlock("li", {
      key: 1,
      class: "select-group tw-capitalize tw-font-semibold tw-ml-3 tw-mt-10px tw-mb-5px",
      innerHTML: _ctx.localitiesLabel
    }, null, 8 /* PROPS */, _hoisted_10)) : _createCommentVNode("v-if", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localityList, locality => {
      return _openBlock(), _createElementBlock("li", {
        key: locality.localityID,
        "data-element": "",
        "data-place-id": locality.placeID,
        "data-url": locality.zoneURL,
        title: locality.localityName
      }, [_createVNode(_component_radio_button, {
        class: "!tw-mx-10px !tw-mb-0 !tw-py-15px tw-flex tw-items-center",
        "label-classes": "tw-pl-10px",
        "is-checked": _ctx.isLocationSelected(locality.localityID),
        label: locality.localityName,
        onChange: $event => {
          _ctx.removeTopLocalitySelected();
          _ctx.onPlaceLIClick(locality, _ctx.updatePlaceName, true);
          _ctx.disableCb = true;
        }
      }, null, 8 /* PROPS */, ["is-checked", "label", "onChange"])], 8 /* PROPS */, _hoisted_11);
    }), 128 /* KEYED_FRAGMENT */))])], 512 /* NEED_PATCH */)) : _createCommentVNode("v-if", true), !_ctx.valuation && !_ctx.showZoneModal ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_base_button, {
      type: "button",
      class: "!tw-border-w-secondary !tw-font-regular tw-my-10px !tw-flex tw-items-center tw-w-full !tw-rounded-xs !tw-px-10px",
      "btn-class": "tw-btn-w-primary tw-btn-outline",
      onClick: _cache[4] || (_cache[4] = $event => {
        _ctx.aroundMe = false;
        _ctx.openMapDraw();
      })
    }, {
      default: _withCtx(() => [_createVNode(_component_draw_icon, {
        width: 16,
        height: 16,
        class: "tw-mr-10px"
      }), _createTextVNode(" " + _toDisplayString(_ctx.labels.drawOnMap), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    }), _createVNode(_component_base_button, {
      type: "button",
      class: "!tw-border-w-secondary !tw-font-regular tw-my-10px !tw-flex tw-items-center tw-w-full !tw-rounded-xs !tw-px-10px",
      "btn-class": "tw-btn-w-primary tw-btn-outline",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.openMapAroundMe())
    }, {
      default: _withCtx(() => [_createVNode(_component_location_icon, {
        width: 16,
        height: 16,
        class: "tw-mr-10px"
      }), _createTextVNode(" " + _toDisplayString(_ctx.labels.closeOnYou), 1 /* TEXT */)]),
      _: 1 /* STABLE */
    })])) : _createCommentVNode("v-if", true)]),
    _: 2 /* DYNAMIC */
  }, [_ctx.cityModal && !_ctx.valuation && _ctx.placeTest.cityID !== null || _ctx.showZoneModal ? {
    name: "footer",
    fn: _withCtx(() => [_createElementVNode("button", {
      class: "tw-btn tw-btn-w-primary tw-w-full",
      onClick: _cache[6] || (_cache[6] = _withModifiers($event => _ctx.confirmPlace(), ["stop"]))
    }, _toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)]),
    key: "0"
  } : undefined]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["show-modal", "header-title", "with-custom-footer", "onClosed"]);
}